import { memo, useEffect, useMemo } from "react";

import { useDispatch, useSelector } from "react-redux";

import { BenchmarkControllers } from "app/pages/benchmark-tracker/config";
import Metric from "app/pages/benchmark-tracker/components/Report/Metric/Metric";
import { PdfHeader } from "app/pages/benchmark-tracker/components/Report/PdfHeader/PdfHeader";
import { MetricsContainer } from "app/pages/benchmark-tracker/components/Report/PdfMetric/styles";
import { getIsMetricsFetched } from "app/pages/benchmark-tracker/helpers/apiHelpers";
import { selectAllMetrics } from "app/pages/benchmark-tracker/store/selectors/reportSelectors";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { getBenchmarkEffect, getTabMetricsEffect } from "../../../store/effects/report";
import { metrics, METRICS_BY_CONTROLLER } from "../Tab/config";

export const PdfMetric = memo(() => {
    const dispatch = useDispatch();

    const selectedMetrics = useSelector(selectAllMetrics);

    const { key: benchmarkId, duration, country, granularity } = proNavigator.getParams();

    const allMetricsMapping = useMemo(() => [...metrics.overview, ...metrics.engagement], []);

    useEffect(() => {
        dispatch(getBenchmarkEffect(benchmarkId));
    }, [dispatch, benchmarkId]);

    useEffect(() => {
        const getMetricsData = async () => {
            const isAllMetricsFetched = getIsMetricsFetched(selectedMetrics);

            if (!isAllMetricsFetched) {
                const metricsToRequestList = [...METRICS_BY_CONTROLLER.overview, ...METRICS_BY_CONTROLLER.engagement];

                try {
                    await dispatch(
                        getTabMetricsEffect(
                            BenchmarkControllers.engagement,
                            benchmarkId,
                            country,
                            duration,
                            granularity,
                            metricsToRequestList,
                        ),
                    );
                } catch {
                    // no need to do anything, error already reported and no specific error UI used for the whole report
                }
            }
        };

        void getMetricsData();
    }, []);

    return (
        <MetricsContainer>
            <PdfHeader />

            {allMetricsMapping.map((metricProps, index) => (
                <Metric
                    {...metricProps}
                    key={index + metricProps.name}
                    className="avoidBreakInside"
                />
            ))}
        </MetricsContainer>
    );
});

PdfMetric.displayName = "PdfMetric";
